import { render, staticRenderFns } from "./MyCards.vue?vue&type=template&id=2993b366&scoped=true"
import script from "./MyCards.vue?vue&type=script&lang=js"
export * from "./MyCards.vue?vue&type=script&lang=js"
import style0 from "./MyCards.vue?vue&type=style&index=0&id=2993b366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2993b366",
  null
  
)

export default component.exports